import { useFetchPageV2 } from "~/core/composables/useFetchPageV2";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_IN,
  OPERATOR_RSQL_LIKE,
} from "~/core/models/filters";
import filtersUtils from "~/core/utils/filters.utils";
import pkiService from "~/modules/pki/services/pki.service";

export function useFetchPkis() {
  const service = pkiService.getPkis.bind(pkiService);

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.PKI_ALIAS,
      {
        key: "alias",
        operator: OPERATOR_RSQL_LIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.PKI_TRUST_CHAIN_ALIAS,
      {
        key: "trustChainAlias",
        operator: OPERATOR_RSQL_IN,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
  );
  const { sort, onSortChange } = useSort();
  const { results, error, isLoading, fetchData } = useFetchPageV2({
    service,
    searchParams,
    sort,
  });

  return {
    isLoading,
    results,
    error,
    filters,
    fetchData,
    setFilter,
    onSortChange,
    search,
    onSearch,
  };
}
